export default __webpack_public_path__ + "static/media/2-Cloudxier-PTBIS.a224967c.png";